import TransCompatibleLink from 'components/TransCompatibleLink';
import { Trans } from 'react-i18next';
import tapEvent from 'lib/Tracking/LeadForm/TapEvent';
import VdpEventContext from 'contexts/VdpEventContext';
import { useContext } from 'react';
import useEvents from 'lib/hooks/useEvents';
import { colors } from 'components/styles/variables';
import LeadFormTrackingContext from 'components/Vdp/LeadFormTrackingContext';

export default function Terms({ termsClassName }: { termsClassName?: string }): JSX.Element {
  const { trackingParams } = useContext(VdpEventContext);
  const logger = useEvents();
  const eventData = useContext(LeadFormTrackingContext);

  return (
    <div className={`terms-text ${termsClassName}`}>
      <Trans
        i18nKey="leadForm.terms"
        components={[
          <TransCompatibleLink data-testid="terms" href={'/pages/terms'}>
            <a
              data-testid="terms"
              onClick={(): void => {
                logger.log(tapEvent({ action: 'terms_of_use', trackingParams, ...eventData }));
              }}
            >
              Terms of Use
            </a>
          </TransCompatibleLink>,
          <TransCompatibleLink data-testid="privacy" href={'/pages/privacy'}>
            <a
              onClick={(): void => {
                logger.log(tapEvent({ action: 'privacy_policy', trackingParams, ...eventData }));
              }}
              data-testid="privacy"
            >
              Privacy Policy
            </a>
          </TransCompatibleLink>,
        ]}
      />
      <style jsx>{`
        .terms-text {
          text-align: left;
          font-size: 10px;
          font-weight: 300;
          color: ${colors.BLACK};
          text-decoration: none;
        }

        .terms-text :global(a) {
          font-size: 10px;
          color: ${colors.BLACK};
        }

        .terms-text.padding {
          padding: 0px 16px 8px 16px;
        }
      `}</style>
    </div>
  );
}
